const actions = {
  async listTemplateRole(context, payload) {
    try {
      const response = await this.$api.call("template_role.list", payload);
      const responseData = response.data;

      context.commit("mutationOrganizationsTemplateRole", responseData);

      return response;
    } catch (error) {
      context.commit("mutationOrganizationsTemplateRole", []);
      throw error;
    }
  },

  async listProductCategories(context, payload) {
    try {
      const response = await this.$api.call("product_categories.list", payload);
      const responseData = response.data;

      context.commit("mutationOrganizationsProductCategories", responseData);

      return response;
    } catch (error) {
      context.commit("mutationOrganizationsProductCategories", []);
      throw error;
    }
  },

  async list(context, payload) {
    try {
      const response = await this.$api.call("organization.list", payload);
      const responseData = response.data;

      context.commit("mutationOrganizations", responseData);

      return response;
    } catch (error) {
      context.commit("mutationOrganizations", []);
      throw error;
    }
  },

  async detail(context, payload) {
    try {
      const response = await this.$api.call("organization.detail", payload);
      const responseData = response.data;

      if (payload.shouldMutateStore !== false) {
        context.commit("mutationOrganization", responseData);
      }

      return response;
    } catch (error) {
      context.commit("mutationOrganization", {});
      throw error;
    }
  },

  async create(_context, payload) {
    try {
      const response = await this.$api.call("organization.create", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async edit(_context, payload) {
    try {
      const response = await this.$api.call("organization.edit", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async delete(_context, payload) {
    try {
      const response = await this.$api.call("organization.delete", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  destroyStates(context) {
    context.commit("mutationOrganization", {});
    context.commit("mutationOrganizations", []);
    context.commit("mutationOrganizationsTemplateRole", []);
    context.commit("mutationOrganizationsProductCategories", []);
  },
};

export default actions;
